import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

export type DoodleKind = 'owl' | 'fox' | 'hoard' | 'sprout' | 'island' | 'quill' | 'bird';

/**
 * Small storybook creatures and objects tucked into the margins of the landing pages.
 * Each one is used once and moves only a little (a blink, a sway, a breath), so they
 * add some play without competing with the content. Size and placement belong to the host.
 */
@Component({
  selector: 'app-doodle',
  templateUrl: './doodle.component.html',
  styleUrls: ['./doodle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {'aria-hidden': 'true'}
})
export class DoodleComponent {
  @Input({required: true}) kind!: DoodleKind;
}
